export default __webpack_public_path__ + "static/media/triangle_star.541c141a.svg";